import moment from 'moment';

export const setMomentLocale = () => {
	moment.locale('is', {
		months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
		monthsShort: 'jan._feb._mar_.apr._maí._jún._júl._ágú._sept._okt._nóv._des.'.split('_'),
		weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
		weekdaysShort: 'sun._mán._þri._mið._fim._fös._lau.'.split('_'),
		weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
		longDateFormat: {
			LT: 'HH:mm',
			LTS: 'HH:mm:ss',
			L: 'DD/MM/YYYY',
			LL: 'D MMMM YYYY',
			LLL: 'D MMMM YYYY LT',
			LLLL: 'dddd D MMMM YYYY LT'
		},
		calendar: {
			sameDay: '[Í dag klukkan] LT',
			nextDay: '[Á morgun klukkan] LT',
			nextWeek: 'dddd [klukkan] LT',
			lastDay: '[Í gær klukkan] LT',
			lastWeek: 'dddd [seinustu viku] LT',
			sameElse: 'L'
		},
		relativeTime: {
			future: 'eftir %s',
			past: 'fyrir %s síðan',
			s: 'örfáum sekúndum',
			m: 'mínútu',
			mm: '%d mínútum',
			h: 'klukkustund',
			hh: '%d klukkustundum',
			d: 'degi',
			dd: '%d dögum',
			M: 'mánuði',
			MM: '%d mánuðum',
			y: 'ári',
			yy: '%d árum'
		},
		ordinalParse: /\d{1,2}(er|ème)/,
		ordinal: function(number) {
			return number;
		},
		meridiemParse: /PD|MD/,
		isPM: function(input) {
			return input.charAt(0) === 'M';
		},
		// in case the meridiem units are not separated around 12, then implement
		// this function (look at locale/id.js for an example)
		// meridiemHour : function (hour, meridiem) {
		//     return /* 0-23 hour, given meridiem token and hour 1-12 */
		// },
		meridiem: function(hours) {
			return hours < 12 ? 'PD' : 'MD';
		},
		week: {
			dow: 1, // Monday is the first day of the week.
			doy: 4 // The week that contains Jan 4th is the first week of the year.
		}
	});
};

export default setMomentLocale;
